module.exports = __webpack_public_path__ + "assets/uniodonto.f9d46013dfe0f88a2b3b6b96503a800c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/uniodonto.png
 ** module id = 465
 ** module chunks = 0
 **/